<template>
  <div
    class="col-container"
  >
    <template
      v-for="comp in childData"
      :key="comp.EntityID"
    >
      <ModuleLayout
        :module-info="{Module: comp}"
      >
        <component
          :is="comp.ModuleVariation?.Title.replace(/\s/g, '')"
          :module-info="{Module: comp}"
        />
      </ModuleLayout>
    </template>
  </div>
</template>

<script>
import {layoutColMixin} from "@/mixins";
import ModuleLayout from "@/components/layouts/ModuleLayout.vue"

export default {
  name: "LayoutsCol",
  components: {
    ModuleLayout
  },
  mixins: [layoutColMixin],
  props: {
    moduleInfo: {
      type: Object,
      required: true
    },
  },
  computed: {
    gotChildData: function () {
      return this.childData?.length > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.row-container{
    @apply max-w-screen-xl mx-auto;
    @screen lg{
     @apply flex max-w-screen-xl;
    }
    //ako korisnik doda više od 2 kolone u editu, neće se prikazati
    .col-container{
      @apply hidden;
    }
    .col-container:first-child{
       @apply block;
      @screen lg{
        flex-basis: 75%;
      }
    }
    .col-container:nth-child(2){
      @apply block;
      @screen lg{
          flex-basis: 25%;
          min-width: 360px;
          max-width: 360px;
      }
    }
}
</style>
